import { render } from "./ChangeTagsModal.vue?vue&type=template&id=3a6e9d20&scoped=true"
import script from "./ChangeTagsModal.vue?vue&type=script&lang=js"
export * from "./ChangeTagsModal.vue?vue&type=script&lang=js"

import "./ChangeTagsModal.vue?vue&type=style&index=0&id=3a6e9d20&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a6e9d20"]])

export default __exports__